import { render, staticRenderFns } from "./RfxListBase.vue?vue&type=template&id=08c31858"
import script from "./RfxListBase.vue?vue&type=script&lang=js"
export * from "./RfxListBase.vue?vue&type=script&lang=js"
import style0 from "./RfxListBase.vue?vue&type=style&index=0&id=08c31858&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports